export default {
  // 问题分类
  className: 'hotWord',
  fields: [
    {
      name: 'name',
      validators: [
        (value) => value ? null : '分类名称不可为空'
      ]
    },
    {
      name: 'heat'
    }
  ],
  search: [
    'name'
  ],
  action: {
    export: false
  }
}
